import { useMemo } from 'react';

import type { FilterMeta, FilterType } from '../../../types/filter-meta';
import type { FilterOperatorOption } from '../shared/filter-operator-select';
import { DEFAULT_OPERATORS, OPERATOR_LABELS_BY_TYPE } from '../../../constants/filter-operators';

/**
 * Shared hook that computes operator options from filter type and meta.
 */
export function useOperatorOptions(
  filterType: FilterType,
  filterMeta: FilterMeta | undefined,
): readonly FilterOperatorOption[] {
  return useMemo(() => {
    if (!filterMeta) return [];
    const ops = filterMeta.operators ?? DEFAULT_OPERATORS[filterType];
    const labels = OPERATOR_LABELS_BY_TYPE[filterType];
    return ops.map((op) => ({ value: op, label: labels[op as keyof typeof labels] }));
  }, [filterType, filterMeta]);
}
